import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSamsung = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#samsung_svg__a)' rx={9.5} />
    <defs>
      <pattern id='samsung_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#samsung_svg__b' transform='scale(.00049)' />
      </pattern>
      <image
        xlinkHref='/images/icons/samsung-690ee9f0.webp'
        id='samsung_svg__b'
        width={2048}
        height={2048}
      />
    </defs>
  </svg>
);
export default SvgSamsung;
